var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "25px",
    viewBox: "0 0 29 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home-svgrepo-com") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.Confirmation-after-submission",
    transform: "translate(-16.000000, -63.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-svgrepo-com",
    transform: "translate(16.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,24.3780963 C3.33333333,24.3780963 3.30811348,25 3.91803822,25 C4.67700868,25 10.9496142,24.9915674 10.9496142,24.9915674 L10.9601848,19.2458101 C10.9601848,19.2458101 10.860821,18.2992516 11.7815219,18.2992516 L14.7000699,18.2992516 C15.7899008,18.2992516 15.7233059,19.2458101 15.7233059,19.2458101 L15.7106211,24.9736482 C15.7106211,24.9736482 21.6597657,24.9736482 22.5942084,24.9736482 C23.3679778,24.9736482 23.3330947,24.1999578 23.3330947,24.1999578 L23.3330947,13.604406 L13.6313803,5 L3.33333333,13.6054601 C3.33333333,13.6054601 3.33333333,24.3780963 3.33333333,24.3780963 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.6102853 C0,12.6102853 0.886825818,14.2371434 2.82474422,12.6102853 L14.3996463,2.87368899 L25.2509158,12.5494382 C27.492674,14.1570815 28.3333333,12.5494382 28.3333333,12.5494382 L14.3996463,0 L0,12.6102853 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "25 2.5 22.5 2.5 22.510581 5.93785047 25 8.33333333"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3a978693d4bc9374203ce293b61de932.svg";
export { ForwardRef as ReactComponent };